import Swiper from 'swiper';

// ------------------------------------------------
//	スクロールアニメーション（.anim → .active）
//	fadeInUp / シャッター(img-wrap2) 共通トリガー
// ------------------------------------------------
const funcAnim = () => {
	const items = document.querySelectorAll('.anim');
	if (!items.length) return;

	const check = () => {
		const th = window.innerHeight * 0.9;
		items.forEach((el) => {
			if (el.classList.contains('active')) return;
			const r = el.getBoundingClientRect();
			if (r.top < th && r.bottom > 0) el.classList.add('active');
		});
	};

	check();
	if (document.readyState !== 'complete') {
		window.addEventListener('load', check, { once: true });
	}
	window.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
};

// ------------------------------------------------
//	KV/Gallery: CSS純正の連続スクロール（JS不要で動くためJSでの制御なし）
// ------------------------------------------------
// ------------------------------------------------
//	swiper（Details Sidebar 商品カード×4、各カード独立インスタンス）
// ------------------------------------------------
const funcSlider = () => {
	const items = document.querySelectorAll('.keds__details-item');
	if (!items.length) return;

	// スライド間隔はJSのspaceBetweenのみで指定し、CSS側にmarginを重複させない（creamymami事故の教訓）。
	// 少数枚(2〜3)のため slidesPerView は最も標準的な 1 を使う（'auto'+loopの既知の弱点を避ける）。
	// paginationはデザインのドットインジケータ（6px正円・active #6ea69c）。要素はスライダー外に配置しているため個別に渡す。
	const swipers = [...items].map((item) => {
		const el = item.querySelector('.swiper-container');
		if (!el) return null;
		return new Swiper(el, {
			loop: true,
			slidesPerView: 1,
			spaceBetween: 50, // 実測50px前後（一部43pxの誤差は統一値で運用）
			speed: 600,
			allowTouchMove: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			pagination: {
				el: item.querySelector('.swiper-pagination'),
				clickable: true,
			},
		});
	}).filter(Boolean);

	// 画像読み込み完了前の幅計測で初期位置がズレるケースに備え、全画像ロード後に再計算＋1枚目へ強制的に位置合わせ
	window.addEventListener('load', () => {
		swipers.forEach((s) => {
			s.update();
			s.slideToLoop(0, 0, false);
		});
	});
};

// ------------------------------------------------
//	スムーススクロール（.anchor）
// ------------------------------------------------
const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1);

const funcSmoothScroll = () => {
	const duration = 500;
	document.querySelectorAll('.anchor').forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			const href = trigger.getAttribute('href');
			if (!href || !href.startsWith('#')) return;
			const target = document.getElementById(href.slice(1));
			if (!target) return;

			e.preventDefault();
			e.stopPropagation();

			const start = window.scrollY || 0;
			const dest = start + target.getBoundingClientRect().top;
			const dist = dest - start;
			const startTime = performance.now();

			const loop = (now) => {
				const nt = (now - startTime) / duration;
				if (nt < 1) {
					window.scrollTo(0, start + dist * easeInOut(nt));
					requestAnimationFrame(loop);
				} else {
					window.scrollTo(0, dest);
				}
			};
			requestAnimationFrame(loop);
		});
	});
};

window.addEventListener('DOMContentLoaded', () => {
	funcAnim();
	funcSlider();
	funcSmoothScroll();
});
